import { ParticipationState } from './FriendsUpcomingParticipations.types'

export const NUMBER_OF_UPCOMING_PARTICIPATIONS_TO_LOAD = 10

export const participationStateTranslation = {
  [ParticipationState.PARTICIPATION_STATE_BOOKED]: 'participation-state-booked',
  [ParticipationState.PARTICIPATION_STATE_JOINED]: 'participation-state-joined',
} as const
